import * as React from 'react';
import Toolbar from './Toolbar';
import { ICertificateData } from '../../entities/table';
import { Head } from './Head';
import { Body } from './Body';
import Table from '../Table';
import { deleteDiplomaFolder } from '../../lib/store/projects/thunks';
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../lib/store';
import { useState } from 'react';
import ConfirmationDialog from '../ConfirmationDialog';

interface IProps {
  rows: ICertificateData[]
}

export const CertificatesTable: React.FC<IProps> = ({rows}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState<ICertificateData | null>(null);

  const onDelete = (row: ICertificateData) => {
    setSelectedRow(row);
    setOpenDeleteModal(true);
  }

  const deleteAction = (row: ICertificateData) => {
    setDeleteLoading(true);
    dispatch(deleteDiplomaFolder({institution: row.institution!, year: row.annee_obtention!, grade: row.grade!, program: row.program!, hash: row.hash!}))
        .then(() =>  toast.success('dossier supprimé avec succès'))
        .catch(() =>  toast.error('Une erreur est survenue ... veuillez contacter le support si l\'erreur persiste.'))
        .finally(() => {
          setDeleteLoading(false);
          setOpenDeleteModal(false);
        });
  }
  return (
    <>
      <Table Head={Head} Body={Body} rows={rows} Toolbar={Toolbar} onDelete={onDelete} />;
      <ConfirmationDialog actionLabel="Suppression" loading={deleteLoading} open={openDeleteModal} close={() => setOpenDeleteModal(false)} action={() => deleteAction(selectedRow!)}/>
    </>
  )
}
